var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyClipboardSvg = function SvgCopyClipboardSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00504A",
    d: "M9.75 1.25H3.469a.094.094 0 0 0-.094.094V2c0 .052.042.094.094-1.906H9.28v10.062c0 .052.042.094.094.094h.656a.094.094 0 0 0 .094-.094V1.625a.375.375 0 0 0-.375-.375m-1.5 1.5h-6a.375.375 0 0 0-.375.375v6.22c0 .099.04.194.11.264l2.031 2.03a.4.4 0 0 0 .087.065v.023h.049a.4.4 0 0 0 .129.023H8.25a.375.375 0 0 0 .375-.375v-8.25a.375.375 0 0 0-.375-.375m-4.148 7.784-1.01-1.01h1.01zm3.68.372h-2.93V9.242a.47.47 0 0 0-.47-.469H2.72v-5.18H7.78z"
  })));
};
export default SvgCopyClipboardSvg;